<template>
  <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0">
      <v-app-bar
              outlined
              flat
              color="white"
              height="52px"
              style="border-bottom: 1px solid #EDEDED !important; z-index: 99;"
      >
          <div class="d-flex flex-row" style="max-width: 200px">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <a href="https://app.motiverse.de/motiverse" target="_blank" v-on="on" v-bind="attrs">
                          <img :src="logo.symbol.url" :alt="logo.symbol.alt" :width="logo.symbol.size"
                               style="max-width: unset !important;">
                      </a>
                  </template>
                  <span>Zu Motiverse</span>
              </v-tooltip>
              <div class="d-flex flex-column ml-2 justify-center">
                  <img :src="logo.typo.url" :alt="logo.typo.alt" :width="logo.typo.size" style="max-width: unset
                !important; margin-top: 3px;">
                  <span class="cursor-default"
                        style="margin-top: 2px;font-size: 10px; font-weight: 600; color:var(--motiverse-secondary);">Prozessmodellierung
                </span>
              </div>
          </div>
          <v-spacer></v-spacer>
          <div>
              <span v-if="selectedTabData.editingMode">
                  <v-icon color="primary" style="transform: rotate(-90deg);" class="mr-2">mdi-sitemap</v-icon>
              </span>
              <span class="mr-2 h4">{{ selectedTabData.fileName }}</span>
              <span v-if="selectedTabData && selectedTabData.editingMode" class="text-tag">.bpmn</span>
          </div>
          <v-spacer :style="'flex-grow: '+setSpacerMargin()+' !important;'"></v-spacer>
          <div id="modelingButtons" class="mr-4">
              <!-- <IconTooltipButtonBottom
                      icon="mdi-menu"
                      tooltip="Menü öffnen"
                      id="default"
                      v-if="!showSidePanel"
                      @click="showSidePanel = true"
              /> -->
              <!-- <IconTooltipButtonBottom
                      icon="mdi-menu"
                      tooltip="Menü schließen"
                      id="default"
                      color="primary"
                      v-if="showSidePanel"
                      @click="showSidePanel = false"
              /> -->
              <!-- <IconTooltipButtonBottom
                      icon="mdi-content-save-outline"
                      :tooltip="$t('save')"
                      id="default"
                      v-if="selectedTabData && selectedTabData.editingMode"
                      @click="saveFile()"
              />

              <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                      <v-tooltip bottom>
                          <template #activator="{ on: onTooltip }">
                              <v-btn icon v-bind="attrs" v-on="{ ...on, ...onTooltip }" id="default" style="padding: unset !important; width: 40px;">
                                  <v-icon>mdi-export</v-icon>
                              </v-btn>
                          </template>

                          <span>Exportieren</span>
                      </v-tooltip>
                  </template>
                  <v-list>
                      <v-list-item @click="exportPDF()">
                          <v-list-item-title>PDF-Datei</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="exportXML()">
                          <v-list-item-title>XML-Datei</v-list-item-title>
                      </v-list-item>
                  </v-list>
              </v-menu> -->
          </div>
          <!-- <div>
              <v-btn v-if="!selectedTabData.editingMode && canEdit"
                     elevation="0"
                     color="primary"
                     @click="showConfirmEditMode()">
                  <v-icon small color="white" class="mr-1">mdi-pencil</v-icon>
                  Bearbeiten
              </v-btn>
              <v-btn v-if="selectedTabData && selectedTabData.editingMode"
                     elevation="0"
                     color="primary"
                     @click="endEditing()">
                  <v-icon small color="white" class="mr-1">mdi-pencil-off</v-icon>
                  Bearbeitung beenden
              </v-btn>
          </div> -->
      </v-app-bar>
    <vue-tabs-chrome theme="custom" id="tabs" ref="tab" v-model="tab" :tabs="tabs" @removeTab="removeTab">
    </vue-tabs-chrome>
    <div
      id="left"
      v-bind:class="{
        commentsOpened: showSidePanel,
        commentsClosed: !showSidePanel,
      }"
    >
      <BpmnViewer
        ref="bpmnViewer"
        :diagramXML="selectedTabData.diagramXML"
        :elementsToLabel="selectedTabData.elementsToLabel"
        v-if="selectedTabData && !selectedTabData.editingMode"
        class="fill-height"
        @elementClicked="onElementClicked"
        @createBadge="setBadges"
      />
      <BpmnEditor
        ref="bpmnEditor"
        :diagramXML="selectedTabData.diagramXML"
        v-if="selectedTabData && selectedTabData.editingMode"
        class="fill-height"
        @elementClicked="onElementClicked"
        @createBadge="setBadges"
        @saveFile="saveFile"
      />
      <ConfirmDialog ref="confirmDialog" />
      <InfoDialog ref="infoDialog" />
    </div>
    <div id="right" v-if="showSidePanel" style="margin-top: 1px">
        <v-card style="height: 100%">
            <div
                    style="position: absolute; top: 0; right: 0; left: 0; height:50px;"
                    class="border-bottom"
            >
                <v-tabs v-model="sidemenuTab" color="secondary" fixed-tabs>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab v-if="!selectedTabData.pxMode" href="#comments" class="font-s">
                        Kommentare
                    </v-tab>
                    <v-tab v-if="!selectedTabData.pxMode" href="#documents" class="font-s">
                        Dokumente
                    </v-tab>
                </v-tabs>
            </div>
            <div>
                <v-tabs-items
                        v-model="sidemenuTab"
                        style="position: absolute; top: 50px; right: 0; left: 0; bottom: 0"
                >

                    <v-tab-item :key="2" value="comments">
                        <CommentsSection :uuid="selectedTabData.uuid" :elementId="selectedElement.id" @refresh="processChanged"/>
                    </v-tab-item>
                    <v-tab-item :key="3" value="documents">
                        <DocumentSection :uuid="selectedTabData.uuid" :elementId="selectedElement.id" @refresh="processChanged"/>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </v-card>
    </div>
      <v-progress-linear
              :style="'position: absolute; bottom: 0; display:'+(loadingProgress == 100 ? 'none;' : 'block; z-index:99;')"
              color="gray accent-4"
              :indeterminate="loadingProgress == 100 ? false : true"
              height="4"
              :value="loadingProgress"
      ></v-progress-linear>
<!--       <div :class="showSidePanel ? 'sidePanelExpand pointer' : 'sidePanelCollapsed pointer'"
           @click="showSidePanel =
  !showSidePanel">
          <div v-if="!showSidePanel">
              <v-icon color="secondary" large>mdi-chevron-left</v-icon>
          </div>
          <div v-if="showSidePanel">
              <v-icon color="secondary" large>mdi-chevron-right</v-icon>
          </div>
      </div> -->
  </div>
</template>

<script>
import clientService from "@/components/clientService"
import ConfirmDialog from "@/components/common/ConfirmDialog";
import InfoDialog from "@/components/common/InfoDialog";

import processModelingService from "./process-share-service";

import IconTooltipButton from "@/components/common/IconTooltipButton";

import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
import BpmnEditor from "@/pages/ProcessModeling/BpmnEditor";
import CommentsSection from "@/pages/ProcessModeling/Menu/CommentsSection/CommentsSection";

import DocumentSection from "@/pages/ProcessModeling/Menu/DocumentSection/DocumentSection.vue";

import VueTabsChrome from 'vue-tabs-chrome'
import {hexToRgb, getContrastColor} from '@/components/colorContrast.js'
import axios from 'axios';
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom.vue";
import PxQuestionSection from "@/pages/ProcessModeling/Menu/PxQuestionSection/PxQuestionSection.vue";
import QuestionSection from "@/pages/ProcessModeling/Menu/QuestionSection/QuestionSection.vue";
export default {
  components: {
      QuestionSection, PxQuestionSection,
      IconTooltipButtonBottom,
    IconTooltipButton,
    ConfirmDialog,
    InfoDialog,
    BpmnViewer,
    BpmnEditor,
    CommentsSection,
    DocumentSection,
    VueTabsChrome,
  },
  props: {},
  data: function () {
      return {
          showProcessSharedialog: false,
          showUserListDialog: false,
          fileName: String,
          showSidePanel: false,
          selectedElement: null,
          badgeColor: '#'+this.$store.state.clientColor,
          snackbar: false,
          canEdit: false,
          tabs: [],
          tab: '',
          sidemenuTab: 'comment',
          selectedTabData: [],
          loadingProgress: 0,
          tooling: '',
          logo: {
              symbol: {
                  url: require('@/assets/motiverse_symbol.png'),
                  alt: 'Motiverse Logo Symbol',
                  size: '32px'
              },
              typo: {
                  url: require('@/assets/motiverse_logo-typo.svg'),
                  alt: 'Motiverse Logo Typographie',
                  size: '120px'
              }
          }
    };
  },
  updated(){
    let rgbPrimary = hexToRgb(this.$vuetify.theme.themes.light.primary);
      let foregroundColor = getContrastColor(rgbPrimary);

      // document.getElementById("editTooltip").style.color = foregroundColor;
  },
  mounted: function() {    
    //if(this.$store.state.currentUser.userId != null){
    //  this.$router.push('/modelEdit/'+this.uuid);
    //}else{
    this.canEdit = true;
    this.$store.dispatch('setCustomShareAuthToken', this.buildCustomShareAuthToken(this.clientId, this.token, this.uuid));
    if (this.uuid) {
      processModelingService.getProcessXml(this.uuid).then(async res => {
      
        let diagramXML = res.data;
        processModelingService
        .retrieveModelInformation(this.uuid)
        .then(result => {
          let fileName = result.data.fileName;
          let editingMode = result.data.currentEditor && result.data.currentEditor === this.userId;
          this.initTabs(fileName, diagramXML, null, editingMode);
          this.loadingProgress = 100;
        });
      });
    }
    //}
  },
  watch: {
    uuid: function (val) {
      this.$emit("loading");
      //if (val) this.fetchDiagram();
    },
    tab(val){
      this.selectedTabData = this.tabs.find(item => item.key === val)
    }
  },
  computed: {
    clientId() {
      return this.$route.params.clientId;
    },
    uuid() {
      return this.$route.params.uuid;
    },
    token() {
      return this.$route.params.token;
    },
  },
  methods: {
    initTabs(fileName, diagramXML, elementsToLabel, editingMode){
    let newTabs = [
      {
        label: fileName,
        key: this.uuid,
        uuid: this.uuid,
        closable: false,
        diagramXML: diagramXML,
        elementsTolabel: elementsToLabel,
        editingMode: editingMode,
        fileName: fileName
      }
    ]
    this.tabs.push(...newTabs)
    this.tab = this.uuid;
    this.selectedTabData = newTabs[0];
    },
    openNewModel(uuid) {
      let alreadyOpened = this.tabs.find(item => item.key === uuid);
      if(alreadyOpened != null){
        this.tab = uuid;
        this.selectedTabData = alreadyOpened;
        return;
      }
      this.loadingProgress = 0;
      processModelingService.getProcessXml(uuid).then(async result => {
        let diagramXML = result.data;

        processModelingService
        .retrieveModelInformation(uuid)
        .then(result => {
          let fileName = result.data.fileName;
          let editingMode = false;
          if (
            result.data.currentEditor &&
            result.data.currentEditor === this.userId
          ) {
            editingMode = true;
          } else {
            editingMode = false;
          }
          let newTab = 
            {
              label: fileName,
              key: uuid,
              uuid: uuid,
              closable: true,
              diagramXML: diagramXML,
              editingMode: editingMode,
              fileName: fileName
            }
          
          this.$refs.tab.addTab(newTab)
          this.selectedTabData = newTab;
          this.tab = uuid;
          this.loadingProgress = 100;
        });
      });
    },
    removeTab () {
      this.$refs.tab.removeTab(this.tab)
    },
    onElementClicked(value) {
      this.selectedElement = value;
    },
    endEditing() {
      this.saveFile();
      processModelingService.setEditingMode(this.selectedTabData.uuid, null).then(() => {
        this.selectedTabData.editingMode = false;
        return this.fetchDiagram();
      });
    },
    showConfirmEditMode() {
      processModelingService
        .retrieveModelInformation(this.uuid)
        .then(result => {
          if (result.data.currentEditor == null) {
            this.$refs.confirmDialog
              .open(
                "Bearbeiten",
                "Indem Sie das Prozessmodell bearbeiten, wird es für andere Nutzer für die Bearbeitung gesperrt."
              )
              .then(() => this.editModel());
          } else {
            const currentEditor = result.data.currentEditor;
            const infoMessage =
              "Das Prozessmodell wird gerade von folgendem Nutzer bearbeitet: " +
              currentEditor;
            this.$refs.infoDialog.open(
              "Bearbeitung nicht möglich",
              infoMessage
            );
          }
        })
        .catch(e => console.log(e));
    },
    editModel() {
      processModelingService.setEditingMode(this.selectedTabData.uuid, this.userId).then(() => {
        this.showEditConfirmation = false;
        this.selectedTabData.editingMode = true;
      });
    },
    setBadges(overlays, elementRegistry){
      if(this.selectedTabData.elementsToLabel){
        for (const element of this.selectedTabData.elementsToLabel){
          const badge = processModelingService.createBadge(element);
          if(elementRegistry.get(element.elementId)) overlays.add(element.elementId, badge);
        }
      }
    },
    saveFile() {
      this.$refs.bpmnEditor
        .saveFile()
        .then(xml => {
          processModelingService.uploadFileAsText(this.selectedTabData.uuid, xml).then(() => {
            if(this.$refs.history != null) this.$refs.history.retrieveHistory();
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportXML() {
      let result;
      if (this.selectedTabData.editingMode) {
        result = this.$refs.bpmnEditor.exportXML();
      } else {
        result = this.$refs.bpmnViewer.exportXML();
      }
      if (result != null)
        result
          .then(xml => {
            this.downloadFile(xml);
          })
          .catch(e => console.log(e));
    },
    exportPDF() {
      let result;
      if (this.selectedTabData.editingMode) {
        result = this.$refs.bpmnEditor.exportPDF();
      } else {
        result = this.$refs.bpmnViewer.exportPDF();
      }
      if (result != null)
        result
          .then(svg => {
            this.createPDFandDownload(svg);
          })
          .catch(e => console.log(e));
    },
    createPDFandDownload(svg) {
      const docDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        content: [
          "Prozessmodell für " + this.selectedTabData.fileName,
          {
            svg: svg,
            width: 800,
            height: 500,
            style: "centering"
          }
        ],
        styles: {
          centering: {
            alignment: "center"
          }
        }
      };
      pdfMake.createPdf(docDefinition).download(this.selectedTabData.fileName + ".pdf");
    },
    downloadFile(xml) {
      const file = new Blob([xml], { type: "application/xml" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = this.selectedTabData.fileName + ".bpmn";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    processChanged() {
      this.tooling = '';
      this.fetchDiagram();
    },
    switchModel(uuid){
      this.$router.push("/modelEdit/" + uuid);
    },
    fetchDiagram() {
      //this.loadingProgress = 0;
      processModelingService.getProcessXml(this.selectedTabData.uuid).then(async result => {
        let diagramXML = result.data;

        const elementsWithAttachments = await processModelingService.getElementsWithAttachments(this.selectedTabData.uuid);
        //TODO 401 (Unauthorized) Error thrown
        let elementsToLabel = elementsWithAttachments.data;

        this.selectedTabData.diagramXML = diagramXML;
        this.selectedTabData.elementsToLabel = elementsToLabel;

        this.loadingProgress = 100;
        console.log('loading done')
      });
    },
    buildCustomShareAuthToken(clientId, token, uuid){
      return window.btoa(`${clientId}:${uuid}:${token}`);
    },
      setSpacerMargin(){
          if(!this.selectedTabData.editingMode && this.canEdit) {
              return '1';
          } else if(this.selectedTabData && this.selectedTabData.editingMode) {
              return '0.8';
          }
      }
  }
};
</script>
<style>

.tabs-item.active:after{
content : "";
  position: absolute;
  left    : 5%;
  bottom  : 0;
  height  : 1px;
  width   : 90%;  /* or 100px */
  /*border-bottom:2px solid var(--v-primary-base);*/
}
#tabs{
  padding-top:0px !important;
}
#modelingTooltips{
    width: fit-content; 
    height: fit-content; 
    z-index: 1;
    
}
#editmode{
  position: absolute;
  bottom: 15px;
  left:15px;
  z-index: 1;
}
#top,
#left,
#right {
  position: absolute;
}
#top{
  bottom: 15px;
  left:75px;
  z-index: 1;
  border: 1px solid lightgray;
  background-color: white;
}
#left,
#right {
  top: 52px;
  bottom: 0px;
}
#left {
  left: 0;
}
.commentsOpened {
  right: 350px;
}
.commentsClosed {
  right: 0;
}
#right {
  width: 350px;
  right: 0;
}
.v-window,
.v-window__container,
.v-window-item {
  position: absolute !important;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>
<style lang="less">
.vue-tabs-chrome.theme-custom {
  padding-top: 0;
  background-color: transparent;
  overflow: hidden;
  .tabs-footer,
  .tabs-divider,
  .tabs-background-before,
  .tabs-background-after {
    display: none;
  }
  .tabs-item {
    cursor: pointer;
  }
  .tabs-content {
    overflow: unset;
    border-top: 1px solid #e4e7ed;
  }
  .tabs-background {
    padding: 0;
  }
  .tabs-background-content {
    border-bottom: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    border-radius: 0;
    background-color: var(--gray-color_3);
  }
  .tabs-content {
    height: 32px;
  }
  .active {
    .tabs-background {
      &::before,
      &::after {
        top: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 1px;
        background-color: #fff;
        z-index: 1;
        position: absolute;
      }
    }
  }
}
.sidePanelCollapsed{
  height: 50px;
  position: fixed;
  background-color: #EBEBEB;
  border-radius: 5px 2.5px 2.5px 5px;
  right: 0px;
  top: calc(50% - 55px);
  width: 36px;
  text-align: center;
  background: var(--gray-color_4);
  padding-top: 6px;
}
.sidePanelExpand{
  height: 50px;
  position: fixed;
  background-color: #EBEBEB;
  border-radius: 5px 2.5px 2.5px 5px;
  right: 350px;
  top: calc(50% - 55px);
  width: 36px;
  text-align: center;
  background: var(--gray-color_4);
  padding-top: 6px;
}
</style>